export default __webpack_public_path__ + "static/media/customSoftware.220a8196.JPG";